/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Unit_Reactions_GivenInputs */



/**
* | output |
* | --- |
* | "reactions given" |
*
* @param {Perks_Unit_Reactions_GivenInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_unit_reactions_given = /** @type {((inputs?: Perks_Unit_Reactions_GivenInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Unit_Reactions_GivenInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("поставленных реакций")
	return /** @type {LocalizedString} */ ("reactions given")
});